import api from '../api/api'
import url from '../api/env'

const getProductsCategories = async (category = '', excludeChars, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.ProductCategory_options}?sort_type=${sort_type}&paginate=0&name=%${encodeURIComponent(category)}%` : encodeURI(`${url.stage.ProductCategory_options}?sort_type=${sort_type}&paginate=0&name=%${category}%`), {})
    .then(res => res)
    .catch(err => err)

const getProductsSubCategories = async categoryId =>
  api
    .get(`${url.stage.ProductSubCategory_options}?paginate=0&product_category_id=${categoryId}`, {})
    .then(res => res)
    .catch(err => err)


const gettaxes = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.taxes}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.taxes}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})    
    .then(res => res)
    .catch(err => err)

export default {
  getProductsCategories,
  getProductsSubCategories,
  gettaxes,
}
